<app-seamless-header></app-seamless-header>

<section class="extra_padding_for_header">
    <div class="progress-bar-custom">
        <div class="progress-bar-custom__fill"></div>
    </div>

    <div [ngClass]="setPosition ? 'position-fix' : (!moved ? 'center' : 'moved')"
        class="box d-flex flex-column align-items-center justify-content-center">
        <div class="d-flex flex-column welcome-text text-center">
            <div>
                <div>{{userName}}, you could BORROW</div>
                <div>up to R50,000 today</div>
            </div>
            <div class="align-self-center blue_line"></div>
            <div class="snapshot">Get a cash boost and <div class="credit_health">unlock new opportunities
                </div>
            </div>
        </div>
        <section class="full-screen-section" *ngIf="displayDbQuoteSection">

            <div>
                <div class="logo-holder">
                    <img src="../../assets/images/capfinlogo.png" alt="Capfin Logo" width="100px" />
                    <img src="../../assets/images/logoJM.png" alt="JustMoney Logo" width="120px" />
                </div>

                <div class="db-popup-section">
                    <div class="dbpopup-body-container">
                        <div class="d-flex mb-2">
                            <div class="flex-grow-1">
                                <p class="m-0 text-blk dbpopup-fs2 text-start text-wrap">You could qualify for up to </p>
                            </div>
                            <div class="dbpopup-mw">
                                <p class="m-0 dbpopup-fs2 text-blk text-nowrap pad-3">
                                    <span>R 50,000</span>
                                </p>
                            </div>
                        </div>
                        <div class="checklist">
                            <div class="dbpopup-item">
                                <img src="../../assets/images/check-icon-dark.svg">
                                <span class="dbpopup-item-text">Access and manage your loan anytime, anywhere</span>
                            </div>
                            <div class="dbpopup-item">
                                <img src="../../assets/images/check-icon-dark.svg">

                                <span class="dbpopup-item-text">Benefit from personalised interest rates</span>
                            </div>
                            <div class="dbpopup-item">
                                <img src="../../assets/images/check-icon-dark.svg">
                                <span class="dbpopup-item-text">Enjoy peace of mind with no hidden costs</span>
                            </div>
                            <div class="dbpopup-item mb-0">
                                <img src="../../assets/images/check-icon-dark.svg">

                                <span class="dbpopup-item-text">Repayments available over 6 to 12 months</span>
                            </div>
                        </div>
                    </div>

                    <hr class="mt-3 mb-3">

                    <p class="ofxt text-center foot-text">Offer subject to change after further assessment by the solution provider, CapFin.</p>

                    <div class="d-flex justify-content-center primary-btn-container">
                        <button type="submit" (click)="navigateToDashboard()"
                            class="primary-btn m-0 w-100" id="btn_userJourney_capfinOffer_toDashboard_registration"
                            name="btn_userJourney_capfinOffer_toDashboard_registration">View offer</button>
                    </div>
                    <div class="d-flex justify-content-center secondary-btn-container">
                        <button type="button" (click)="SkipCallback()" class="m-0 w-100 secondary-btn"
                            id="btn_auxilaryButton_capfinOffer_dismiss_registration"
                            name="btn_auxilaryButton_capfinOffer_dismiss_registration">Maybe later</button>
                    </div>

                </div>


            </div>

        </section>
    </div>

    <ng-template #callbackStatusModel let-modal>
        <div class="modal-header">
            <h4 class="modal-title fw-bold">Free call-back incoming...</h4>
            <button type="button" class="close" id="btn_auxiliaryButton_splOfferCallbackPopUp_close_registration"
                name="btn_auxiliaryButton_splOfferCallbackPopUp_close_registration" isCloseButton="true"
                data-dismiss="modal" aria-label="Close" (click)="closePopup()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div *ngIf="callbackErrorMsg ==''" class="modal-body">
            <p class="mt-2 mb-0">An agent will contact you shortly</p>
        </div>
        <div *ngIf="callbackErrorMsg!=''" class="modal-body">
            <div class="alert alert-danger" role="alert">
                {{callbackErrorMsg}}
            </div>
        </div>
        <div class="modal-footer dc-success-footer" *ngIf="callbackErrorMsg==''">
            <button type="button" class="primary-success-btn"
                id="btn_userJourney_splOfferCallbackPopUp_toReadyScreen_registration"
                name="btn_userJourney_splOfferCallbackPopUp_toReadyScreen_registration" (click)="closePopup()">OK,
                thanks!</button>
        </div>
    </ng-template>
</section>